import { getAssessmentResult } from "@/lib/freeAssessment";
import { useNavigate } from "react-router-dom";
import AssessmentResult from "./_components/AssessmentResult";

function ResultPage() {
  const navigate = useNavigate();
  const result = getAssessmentResult();
  if (!result) {
    navigate("/free-assessment/info");
    return null;
  }
  return <AssessmentResult result={result} />;
}

export default ResultPage;
